module.exports = __webpack_public_path__ + "static/media/View.7483aaa0.jpg";